/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {DecisionPoint}  from '@/models/scenario/decision.point';
import {
  WorkBlock
}                       from '@/models/scenario/work.block';
import {
  Diversion,
  DiversionType
}                       from '@/models/scenario/diversion';
import {Track}          from '@/models/scenario/track';
import {Train}          from '@/models/scenario/train';
import {TrackIngress}   from '@/helpers/track.ingress';

/**
 *
 * @class DiversionChange
 *
 * @brief basic interface for working with the selected diversion between the
 * various parts of the diversion editor. We don't use an actual diversion,
 * because the selection may also be used for adding or editing a row (a diversion).
 * That is, we need a change carrier.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class DiversionChange {

  /** the object that caused the selection or edit of this diversion */
  public           src: any            = null;

  /** the unique ID for this diversion, at least among diversions */
  public            id: number         = -1;

  /** user label for block */
  public          name: string         = '';

  public          type: DiversionType  = DiversionType.OneWay;

  /** the workblock this diversion is for */
  public          work: WorkBlock      = null;

  /** the west side of the work block */
  public         start: DecisionPoint  = null;

  /** the link to use on west side */
  public    startTrack: TrackIngress   = null;

  /** the east side of the work block */
  public           end: DecisionPoint  = null;

  /** the link to use on east side */
  public       endTrack: TrackIngress  = null;

  /** how long (0..24 hours) the outage is for (in sim time) */
  public       duration: number        = 0;

  /** the std deviation to use for this duration */
  public         stdDev: number        = 0.0;

  /** the days (sim days) where its active */
  public         trains: Train[]       = [];

  /** user description of work */
  public    description: string        = ';';

  /** the actual Diversion model (for add/clone/delete) */
  public          model: Diversion     = null;

  /**
   *
   * some changes have to be paired with the current state of the editing panel;
   * this allows us to rollback to states where the editor has transient data; not
   * yet saved to an actual row.
   *
   */

  public snapshot: DiversionChange = null;

  /** standard constructor, allow anonymous object initialization */
  public constructor(init?: Partial<DiversionChange>) {

    Object.assign(this, init);
  }
}
